import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { RulesApi } from '../../../../shared/services/api/rules.api';
import { Regulamin } from '../../../../shared/models/regulamin';
import { catchError, EMPTY } from 'rxjs';
import { HttpResponseService } from '../../../../core/services/http-error-response.service';

export const ruleDetailsResolver: ResolveFn<Regulamin> = (route) => {
  const api = inject(RulesApi);
  const httpResponseService = inject(HttpResponseService);
  const idParam = route.paramMap.get('id');
  const parsedId = idParam ? Number(idParam) : NaN;

  if (!Number.isFinite(parsedId)) {
    throw new Error('Invalid rule id.');
  }

  return api.getRuleById$(parsedId).pipe(
    catchError((err) => {
      httpResponseService.showErrorMessage(
        err,
        'Wystąpił błąd podczas pobierania regulaminu.',
      );
      return EMPTY;
    }),
  );
};
